
import axios from "axios";
import { store } from "store";
import { OutputBaseProps, PaginationProps } from "utils/types/API";
import { TimeFrameItemProps } from ".";
import { loading, index, options } from "store/time-frame";

interface ApiTimeFrameInputProps {
    page?: number;
    pageSize?: number;
    q?: string;
}

type ApiTimeFrameOutputProps = OutputBaseProps<{ list: TimeFrameItemProps[]; pagination?: PaginationProps; }>

export const apiTimeFrameIndex = async (data: ApiTimeFrameInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiTimeFrameOutputProps>("/api/time-frames", { params: data }))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(index({ data: res.data.list, pagination: res.data.pagination }));
    }
    return res;
};

export const apiTimeFrameOptions = async (data: { q?: string; }) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiTimeFrameOutputProps>("/api/time-frames", { params: { ...data, fields: "id,code,name" } }))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(options({ data: res.data.list }));
    }
    return res;
};